/* ============
 * Register Index Page
 * ============
 *
 * Page where the user can register
 */

import authService from "./../../../services/auth";
import mixin from "../../../mixins/mixin";

export default {
  data() {
    return {
      user: {
        full_name: null,
        email: null,
        password_confirmation: null,
        password: null,
        phone: null,
      },
      smallLoading: false,
      cguAccepted: false,
      showMobileText: false,
    };
  },
  components: {
    VLoading: require("components/loading/loading.vue"),
  },
  watch: {
    "user.phone"(val, oldval) {
      var regExp = /[a-zA-Z\s]/g;
      if (regExp.test(val)) {
        this.user.phone = val.replace(regExp, "");
      }
    },
  },
  mounted() {
    window.location.href = "https://form.superhote.com/rejoindre";
    // if (!window.location.hash.includes("ahwoKyDvL4W28GUjmPYVmIQOcwMhtoFtOw29veG6HOX0PyEf")) {
    //   window.location.href = "https://form.superhote.com/rejoindre";
    // } else {
    //   document.querySelector(".big-container").style.display = "block";
    // }

    // if (window.matchMedia('(max-width: 1000px)').matches) {
    //   this.showMobileText = true;
    // }
  },
  mixins: [mixin],
  methods: {
    async register(user) {
      this.smallLoading = true;
      if ($("input[name='referral']").val()) {
        user.referral_id = $("input[name='referral']").val();
      }
      await authService.register(user, this);
    },
    acceptCGU() {
      this.cguAccepted = !this.cguAccepted;
    },
  },
};



// WEBPACK FOOTER //
// ./src/app/pages/register/index/index.js